import React, { useRef, useState } from "react";
import { mailService } from "../../services/api";

export default function MailLabelPicker({ value, onChange, disabled = false, optional = false }) {
  const [catalog, setCatalog] = useState(null), [busy, setBusy] = useState(false), [error, setError] = useState("");
  const guard = useRef(false);
  const load = async () => {
    if (guard.current) return;
    guard.current = true; setBusy(true); setError(""); onChange(""); setCatalog(null);
    try { setCatalog(await mailService.labels()); }
    catch (failure) { setError(typeof failure.response?.data?.detail === "string" ? failure.response.data.detail : "Labels could not be loaded. Check your Google connection."); }
    finally { guard.current = false; setBusy(false); }
  };
  return <div className="space-y-2">
    <div className="flex flex-wrap items-end gap-3">
      <label className="text-sm font-semibold">Custom Gmail label{optional ? " (optional)" : ""}
        <select className="field-input mt-1" disabled={disabled || busy || !catalog} value={value} onChange={e => onChange(e.target.value)}>
          <option value="">{optional ? "Any label" : "Choose a label"}</option>
          {catalog?.items.map(item => <option key={item.id} value={item.selection_token}>{item.name}</option>)}
        </select>
      </label>
      <button type="button" className="secondary-button" disabled={disabled || busy} onClick={load}>{busy ? "Loading labels…" : catalog ? "Refresh labels" : "Load custom labels"}</button>
    </div>
    {catalog && <p className="text-xs text-[#58635d]">{catalog.mailbox} · {catalog.items.length ? "Choose from your existing Gmail labels. Selections expire after 15 minutes." : "No custom labels in this mailbox. Create one in Gmail, then refresh here."}</p>}
    {error && <p role="alert" className="text-sm text-red-800">{error}</p>}
  </div>;
}
